<template>
    <user-layout>
        <div class="w-full py-6 mx-auto">
            <div class="flex items-center justify-between">
                <section-title 
                    title="Settings"
                    description="View the relevant data and other details"
                />
            </div>
            <div class="mt-6">
                <div class="w-full border rounded-lg border-neutral-100">
                    <div class="relative overflow-auto">
                        <div class="absolute left-0 top-0 h-full whitespace-nowrap position w-[181px] shadow-[2px_0_16px_0px_rgb(0,0,0,0.08)]">
                            <div class="px-6 py-[26px] bg-primary-100 text-sm font-semibold relative">
                                Settings
                            </div>
                            <side-tab formOptionsSelected />
                        </div>
                        <div class="pl-[181px] min-h-[500px]">
                            <div class="flex items-center justify-between p-6 border-b border-neutral-100">
                                <div class="flex items-center space-x-4">
                                    <tab-component
                                        :tabs="tabs"
                                    />
                                </div>
                            </div>
                            <div v-if="route.query.tab != 'activity_logs'">
                                <data-table 
                                    :headers="headers" 
                                    :no-action="false"
                                    :count="items.length"
                                    tableClass="header-frm-table"
                                >
                                    <template v-slot:body>
                                        <template 
                                            v-for="item in items" 
                                            :key="item"
                                        >
                                            <tr>
                                                <td class="px-6 py-[18px] whitespace-nowrap text-sm text-gray-900">
                                                    {{ item.name }}
                                                </td>
                                                <!-- <td class="px-6 py-[18px] whitespace-nowrap text-sm text-gray-900">
                                                    {{ item.dateUpdated }}
                                                </td> -->
                                                <td 
                                                    class="
                                                        px-6
                                                        py-[18px]
                                                        whitespace-nowrap
                                                        text-sm 
                                                        text-gray-900
                                                    "
                                                >
                                                    <div 
                                                        class="flex items-center justify-center mx-auto"
                                                    >
                                                        <view-button
                                                            @click="router.replace(`/settings/form-options/view/${item.route}`)"
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                </data-table>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="w-full px-6 border-t py-7">
                        <minify-pagination num-rows="All"></minify-pagination>
                    </div> -->
                </div>
    
            </div>
        </div>

         <page-loader :show="loading"/>
    </user-layout>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import UserLayout from '@/layouts/UserLayout.vue';
import SectionTitle from '@/components/partials/SectionTitle.vue';
import ViewButton from '@/components/buttons/ViewButton.vue';
import DataTable from '../Components/DataTable.vue';
import SideTab from '../Components/SideTab.vue';
import TabComponent from '@/components/partials/TabComponent.vue';

import FormOptions from '@/classes/Settings/FormOptions'

import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";


import assignValues from "@/helpers/assignValues"
import PageLoader from "@/components/loaders/PageLoader.vue"

import { useRouter } from 'vue-router';

const router = useRouter();

const loading = ref<boolean>(false);

interface FormOptionIndexInterface {
    name: string,
    route: string,
}

const items = ref<FormOptionIndexInterface[]>([]);

const init = ():void => {
    FormOptions.index([])
        .then(({ data }) => {
            items.value = data;

            loading.value = false
        })
        .catch((error: any) => {
            console.log(error);
        });
}

onMounted(() => {
    init()
})

const route = useRoute();
const active_count = ref(15);

const tabs: { name: string, count: number, href: string, allowed: boolean }[] = [
    {
        name: 'All',
        count: 0,
        href: "/settings/form-options/index",
        allowed: true
    }
];

const headers: { text: string, haveSort?: boolean }[] = [
    { text: 'Field Name' },
];

interface sampleDataInfo {
    fieldName: string,
    dateUpdated: string,
}

const sampleData = ref<sampleDataInfo[]> ([
    { 
        fieldName: 'Comorbid',
        dateUpdated: 'Aug 26, 2022 (00:00:00)'
    },
    { 
        fieldName: 'Referral Sources',
        dateUpdated: 'Aug 26, 2022 (00:00:00)'
    },
    { 
        fieldName: 'Religions',
        dateUpdated: 'Aug 26, 2022 (00:00:00)'
    },
    { 
        fieldName: 'Relationships',
        dateUpdated: 'Aug 26, 2022 (00:00:00)'
    },
    { 
        fieldName: 'Services Sought',
        dateUpdated: 'Aug 26, 2022 (00:00:00)'
    },
]);
</script>